import React from 'react';
import { Box, Typography } from '@mui/material';

import assetLoadErrorStyles from './styles';

const AssetLoadError = ({ title, insideModal = false }) => {
    const classes = assetLoadErrorStyles();
    return (
        <Box className={classes.container} style={{ height: insideModal ? '100%' : '100vh' }}>
            <Box className={classes.content}>
                <Box className={classes.title}>
                    <Typography className={classes.text}>{title}</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export { AssetLoadError };
